<template>
  <div class="actividades">
    <b-container>
      <b-row class="center">
        <b-col cols="7">
          <div class="button big"></div>
        </b-col>
        <b-col>
          <div class="text">
            <h1>MANUAL DE ACTIVIDADES DE TIEMPO LIBRE</h1>
            <p>
              El Manual de Actividades de Tiempo Libre nace de la necesidad de ayudar en las
              gestiones realizadas por los Centros Juniors. Recoge la información necesaria para
              adaptarse a los requisitos legales vigentes para asegurar una buena realización de
              las actividades desarrolladas en Juniors M.D.. En él se ofrece un apoyo tanto
              legislativo como administrativo para la gestión de las actividades y consejos
              prácticos para cumplir con la normativa vigente y con las obligaciones que nos
              corresponden como miembros del Movimiento.
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row class="footer">
        <b-col cols="auto" class="mr-auto">
          <router-link to="/gestion">
            <div class="button small back"></div>
          </router-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/manual/actividades.pdf" v-b-tooltip.topright title="Manual de Tiempo Libre">
            <div class="button small download manual"></div>
          </b-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/guia/seguro-tiempo-libre.pdf" v-b-tooltip.topleft title="Guía del seguro de Tiempo Libre">
            <div class="button small download guia"></div>
          </b-link>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>

export default {
  name: 'actividades'
}
</script>

<style lang="scss" scoped>
@import '../styles/common.scss';
</style>
